<main class="bg-black text-white min-h-screen overflow-x-hidden">
  <section class="relative min-h-[85vh] flex items-center pt-24 pb-16 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 -right-48 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="absolute inset-0 opacity-[0.025]"
      style="background-image: linear-gradient(rgba(0,170,230,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(0,170,230,0.5) 1px, transparent 1px); background-size: 60px 60px;">
    </div>

    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="grid md:grid-cols-[1.05fr,0.95fr] gap-12 items-center">
        <div>
          <a routerLink="/" class="back-nav" data-aos="fade-down">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            Back
          </a>
          <h1 class="hero-col font-black mb-6" data-aos="fade-up" data-aos-delay="100">
            Unified <span class="text-varroc-accent">Telematics SDK</span>
          </h1>
          <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 max-w-3xl" data-aos="fade-up"
            data-aos-delay="200">
            The Unified Telematics SDK enables connected mobility experiences through a single, scalable, and extensible
            platform. It supports multiple data sources and device types, including <b>OBDs, TCUs, Dashcams, IoT
              devices, and deviceless telematics (mobile-based telematics)</b>, allowing organizations to build, deploy,
            and scale connected vehicle solutions effortlessly.
            The SDK facilitates seamless data collection and processing from both mobile applications and in-vehicle
            devices, providing a unified framework for connected mobility services. This multi-device approach enables
            consistent user experiences across mobile, vehicle, and cloud platforms. </p>
          <!-- <p class="text-varroc-text-gray text-lg leading-relaxed max-w-3xl" data-aos="fade-up" data-aos-delay="260">
            The platform powers a wide range of connected mobility capabilities, including trip tracking, driving
            behavior analysis, driver insights, safety services, rewards programs, fleet and vehicle monitoring, and
            ecosystem integrations. These capabilities are delivered consistently across mobile applications, vehicle
            interfaces, and connected devices, enabling organizations to rapidly introduce and scale innovative mobility
            services.</p> -->
        </div>

        <div class="grid gap-5 mt-[1.5rem]" data-aos="fade-left" data-aos-delay="200">
          <p class="text-varroc-text-gray text-lg leading-relaxed max-w-3xl" data-aos="fade-up" data-aos-delay="260">
            The platform powers a wide range of connected mobility capabilities, including trip tracking, driving
            behavior analysis, driver insights, safety services, rewards programs, fleet and vehicle monitoring, and
            ecosystem integrations. These capabilities are delivered consistently across mobile applications, vehicle
            interfaces, and connected devices, enabling organizations to rapidly introduce and scale innovative mobility
            services.</p>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
        <div *ngFor="let item of overviewHighlights" class="feature-card text-left">
          <div class="text-varroc-accent font-black text-xl xl:text-2xl mb-2">
            {{ item.val }}
          </div>
          <div class="text-varroc-text-gray text-sm leading-relaxed">
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
  </section>

  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id"
          class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>

  <div class="max-w-7xl mx-auto px-6 py-20 space-y-32">
    <section id="overview" class="section-anchor">
      <div class="grid lg:grid-cols-[1fr,0.95fr] gap-10 items-start">
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Overview</span>
          <h2 class="text-4xl font-black mt-2 mb-4">A Single Platform for Connected Mobility Delivery</h2>
          <p class="text-varroc-text-gray text-lg leading-relaxed mb-5">The Unified Telematics SDK enables organizations
            to collect, process, and activate connected vehicle data through mobile applications and in vehicle systems
            without managing fragmented implementation paths.</p>
          <p class="text-varroc-text-gray leading-relaxed">It gives product teams one scalable foundation for connected
            driving experiences, driver insights, safety, rewards, and partner led mobility services.</p>
        </div>
        <div class="feature-card" data-aos="fade-left">
          <h3 class="text-white font-bold text-lg mb-4">What It Powers</h3>
          <ul class="space-y-3">
            <li class="flex items-start gap-3 text-varroc-text-gray text-sm"><i
                class='bx bx-check-circle icon-gradient mt-0.5 flex-shrink-0'></i><span>Trip tracking and route
                intelligence across interfaces.</span></li>
            <li class="flex items-start gap-3 text-varroc-text-gray text-sm"><i
                class='bx bx-check-circle icon-gradient mt-0.5 flex-shrink-0'></i><span>Driver safety, scoring, and live
                notifications from one platform layer.</span></li>
            <li class="flex items-start gap-3 text-varroc-text-gray text-sm"><i
                class='bx bx-check-circle icon-gradient mt-0.5 flex-shrink-0'></i><span>Rewards, ecosystem services, and
                digital in vehicle experiences at scale.</span></li>
          </ul>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="problem" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-start">
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Problem Statement</span>
          <h2 class="text-4xl font-black mt-2 mb-4">Connected Vehicle Delivery Gets Slowed by Fragmentation</h2>
          <p class="text-varroc-text-gray text-lg leading-relaxed mb-5">Delivering connected vehicle experiences is
            often slowed down by fragmented systems, hardware dependencies, and complex integrations. Organizations
            struggle to maintain feature consistency, scale new capabilities, and manage multiple technology stacks.</p>
          <p class="text-varroc-text-gray leading-relaxed">Varroc Connect solves this with a common SDK foundation that
            simplifies integration, accelerates development, and supports connected mobility across different
            environments.</p>
        </div>
        <div class="grid gap-4" data-aos="fade-left">
          <div class="feature-card">
            <h3 class="text-white font-bold text-lg mb-3">Why Teams Get Blocked</h3>
            <ul class="space-y-3">
              <li class="flex items-start gap-3 text-varroc-text-gray text-sm"><i
                  class='bx bx-x-circle icon-gradient mt-0.5 flex-shrink-0'></i><span>Disconnected systems make
                  experience consistency difficult across products.</span></li>
              <li class="flex items-start gap-3 text-varroc-text-gray text-sm"><i
                  class='bx bx-x-circle icon-gradient mt-0.5 flex-shrink-0'></i><span>Hardware and platform dependencies
                  increase implementation complexity.</span></li>
              <li class="flex items-start gap-3 text-varroc-text-gray text-sm"><i
                  class='bx bx-x-circle icon-gradient mt-0.5 flex-shrink-0'></i><span>Scaling new connected features
                  requires repeated integration effort.</span></li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="features" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Key Features</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Core Capabilities Across Mobile and Vehicle Interfaces</h2>
        <p class="text-varroc-text-gray max-w-3xl mr-auto">The SDK is designed to support real connected mobility use
          cases across data capture, intelligence, navigation, safety, rewards, and ecosystem enablement.</p>
      </div>
      <div class="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
        <div *ngFor="let feature of keyFeatures; let i = index" class="feature-card" [attr.data-aos]="'fade-up'"
          [attr.data-aos-delay]="(i * 50).toString()">
          <div class="flex items-start gap-3">
            <div class="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i class='bx bx-check-circle icon-gradient text-xl'></i>
            </div>
            <p class="text-varroc-text-gray text-sm leading-relaxed m-0">{{ feature }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="usecases" class="section-anchor">
      <div class="mb-14" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest block mb-3">Use Cases</span>
        <h2 class="text-4xl font-black mb-4">Where the Unified SDK Creates Value</h2>
        <p class="text-varroc-text-gray text-lg max-w-3xl mr-auto">The platform supports connected driving, insurance,
          engagement, fleet operations, service experiences, emergency response, route intelligence, and digital
          ecosystem enablement through one common telematics layer.</p>
      </div>
      <div class="grid md:grid-cols-2 gap-6">
        <div *ngFor="let item of useCases; let i = index" class="feature-card flex items-start gap-5"
          [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 60).toString()">
          <div class="w-12 h-12 bg-varroc-accent/15 rounded-xl flex items-center justify-center flex-shrink-0">
            <i class='bx icon-gradient text-2xl' [class]="item.icon"></i>
          </div>
          <div>
            <h3 class="text-white font-bold text-lg mb-2">{{ item.title }}</h3>
            <p class="text-varroc-text-gray text-sm leading-relaxed">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="impact" class="section-anchor">
      <div class="grid lg:grid-cols-[0.95fr,1.05fr] gap-10 items-start">
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Business Impact</span>
          <h2 class="text-4xl font-black mt-2 mb-4">A Faster and More Scalable Foundation for Mobility Products</h2>
          <p class="text-varroc-text-gray text-lg leading-relaxed">The Unified Telematics SDK reduces platform
            fragmentation and gives teams a repeatable path to launch and scale connected vehicle features across
            products and device environments.</p>
        </div>
        <div class="grid sm:grid-cols-2 gap-4" data-aos="fade-left">
          <div *ngFor="let item of businessImpact" class="feature-card h-full">
            <div class="flex items-start gap-3">
              <div class="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i class='bx bx-check-circle icon-gradient text-xl'></i>
              </div>
              <p class="text-varroc-text-gray text-sm leading-relaxed m-0">{{ item }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="all-features" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">All Features</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Complete Feature Coverage in One SDK Layer</h2>
        <p class="text-varroc-text-gray max-w-3xl mr-auto">The full feature set spans telematics data capture,
          intelligence, notifications, service flows, ecosystem enablement, and in vehicle digital experiences through
          one hardware agnostic framework.</p>
      </div>
      <div class="grid md:grid-cols-2 xl:grid-cols-4 gap-4">
        <div *ngFor="let item of allFeatures; let i = index" class="feature-card h-full" [attr.data-aos]="'fade-up'"
          [attr.data-aos-delay]="(i * 35).toString()">
          <div class="flex items-start gap-3">
            <div class="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i class='bx bx-check-circle icon-gradient text-lg'></i>
            </div>
            <p class="text-varroc-text-gray text-sm leading-relaxed m-0">{{ item }}</p>
          </div>
        </div>
      </div>
    </section>

  </div>
</main>